import { withAuthenticator, Authenticator } from '@aws-amplify/ui-react'
import { Auth } from 'aws-amplify'
import '@aws-amplify/ui-react/styles.css'
import 'react-toastify/dist/ReactToastify.min.css'
import { createGlobalStyle } from 'styled-components'
import './App.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import IntakeContextWrapper from './context/IntakeContext'
import { useState, useEffect } from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import { PageContainer } from 'components/PageContainer/PageContainer'
import { ScrollDownIndicator } from 'components/ScrollDownIndicator'
import { Onboarding } from 'layouts/onboarding'
//onboarding components
import OnboardingFirstLastPhoneDOB from 'components/OnboardingFirstLastPhoneDOB'
import OnboardingMultiQuestion from 'components/OnboardingMultiQuestion'
import AgencyTileSelector from 'components/AgencyTileSelector'
import RetirementSystemTileSelector from 'components/RetirementSystemTileSelector'
import OnboardingSchedule from 'components/OnboardingSchedule'
import OnboardingSelector from 'layouts/onboarding/components/onboardingselector'
import OnboardingSelectorFork from 'layouts/onboarding/components/onboardingselectorfork'
import OnboardingMultiOptionTile from 'components/OnboardingMultiOptionTile'
import OnboardingYesNo from 'components/OnboardingYesNo'
import OnboardingInformation from 'components/OnboardingInformation'
import ServiceCompDate from 'components/ServiceCompDate'
import Banner from 'atoms/Banner.js'
import Gauge from 'atoms/Gauge'
// @mui material components
import { ThemeProvider } from '@mui/material/styles'
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material'
import WorkIcon from '@mui/icons-material/Work'
import BeachAccessIcon from '@mui/icons-material/BeachAccess'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'

// Soft UI Dashboard React themes
import theme from 'assets/theme'
import CalendarIcon from 'assets/images/calendar.svg'
import { AnonymousContext } from 'context/AnonymousContext'
import { SessionInformation } from 'admin/utils/SessionInformation'
import { useIntake } from 'hooks/useIntakeContext'
import { useRetirementGapCalculations } from 'layouts/authenticated/pages/dashboard/hooks/useRetirementGapCalculations'
import { usePARCOScoreCalculations } from 'layouts/authenticated/pages/dashboard/hooks/usePARCOScoreCalculations'
import { useDashboardCalculations } from 'layouts/authenticated/pages/dashboard/hooks/useDashboardCalculations'
import { differenceInYears, format } from 'date-fns'

//Authentication
import { Login } from 'components/Login/Login'
import OauthCallbackPage from 'components/Login/OauthCallbackPage'
import { AuthProvider } from 'components/Authentication/Authentication'
import { signUpUser } from 'utils/aws/authService'

import { callZapier } from 'utils/zapier/callZapier'
import { checkUserLoggedIn } from 'utils/aws/authService'
import { FieldFocusProvider } from 'context/FieldFocusContext'
import OnboardingSelectorHyper from 'layouts/onboarding/components/onboardingselectorhyper'
import ScoreCard from 'components/ScoreCard'
import OnboardingContactDetails from 'components/OnboardingContactDetails'
import OnboardingAge from 'components/OnboardingAge'
import OnboardingServiceCompDate from 'components/OnboardingServiceCompDate'
import OnboardingIncome from 'components/OnboardingIncome'
import { selectData } from 'layouts/onboarding'
import QuilttConnectProvider from 'layouts/authenticated/pages/newdash/components/QuilttConnectProvider'
const ToastStyleOverride = createGlobalStyle`
  :root {
    --toastify-toast-width: auto;
  }
`
let authInitialState =
  window.location.pathname === '/seminar' ||
  window.location.pathname === '/walter-reed' ||
  window.location.pathname === '/onboarding' ||
  window.location.pathname === '/onboarding-full' ||
  window.location.pathname === '/event' ||
  window.location.pathname === '/full' ||
  window.location.pathname === '/ic' ||
  // window.location.pathname === '/' ||
  window.location.pathname === '/complementary' ||
  window.location.pathname === '/report' ||
  window.location.pathname === '/firststep' ||
  window.location.pathname === '/quick'
    ? 'signUp'
    : 'signIn'

const dollarFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
})
// if (process.env.NODE_ENV === 'development' && module.hot && module.hot.accept) {
//   console.log('test')
//   module.hot.accept('./layouts/pages/onboarding/data/steps.js')
//   module.hot.accept('./AppRoutes.js')
// }

// const AuthenticatedStuff = withAuthenticator(() => (
//   <IntakeContextWrapper>
//     <ScrollDownIndicator />
//     <PageContainer />
//   </IntakeContextWrapper>
// ))

const AuthenticatedStuff = () => (
  <AuthProvider initialState={authInitialState} variation="modal">
    <IntakeContextWrapper>
      <FieldFocusProvider>
        <QuilttConnectProvider />
        <ScrollDownIndicator />
        <PageContainer />
      </FieldFocusProvider>
    </IntakeContextWrapper>
  </AuthProvider>
)
// let createdUser = localStorage.getItem('createdUser') === 'true'
// let sentToZapier = localStorage.getItem('sentToZapier') === 'true'

// console.log('sentToZapier', sentToZapier)
// console.log('createdUser', createdUser)

const UnauthedOnboarding = () => {
  authInitialState = 'signUp'
  const { intakeState, updateIntakeStateAtKey } = useIntake()
  const [createdUser, setCreatedUser] = useState(
    localStorage.getItem('createdUser') === 'true'
  )
  const [sentToZapier, setSentToZapier] = useState(
    localStorage.getItem('sentToZapier') === 'true'
  )
  const handleNext = async () => {
    window.scrollTo({ top: -100, behavior: 'smooth' })
    await SessionInformation.setItem('demoUserInput', {
      ...intakeState,
    })
    if (
      intakeState?.firstName !== undefined &&
      intakeState?.lastName !== undefined &&
      intakeState?.phone !== undefined &&
      intakeState?.email !== undefined
    ) {
      if (!createdUser) {
        localStorage.setItem('createdUser', 'true')
        setCreatedUser(true)
        await signUpUser({ ...intakeState })

        //adding in a google tag fire for conversion tracking
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'conversion', {
            send_to: 'AW-17330571457/ffLJCKGyhu4aEMGR7sdA',
          })
        }
      }
    }
    if (
      intakeState?.firstName !== undefined &&
      intakeState?.lastName !== undefined &&
      intakeState?.phone !== undefined &&
      intakeState?.agency !== undefined
    ) {
      if (sentToZapier) return
      await fetch('https://hooks.zapier.com/hooks/catch/15607509/2tb7wuh/', {
        method: 'POST',
        body: JSON.stringify({ user: intakeState }),
      })
      localStorage.setItem('sentToZapier', 'true')
      setSentToZapier(true)
    }
  }
  return (
    <>
      <FieldFocusProvider>
        <Onboarding
          customHandleNext={handleNext}
          steps={[
            {
              id: 'onboardingBasics',
              component: OnboardingFirstLastPhoneDOB,
              type: 'Question',
            },
            {
              id: 'governmentEmployeeSelector',
              type: 'Question',
              component: OnboardingYesNo,
              tags: ['onboarding'],
              props: {
                header:
                  'Do you work for or are you retired from the federal government?',
                subHeader: 'Select one of the following:',
                id: 'governmentEmployee',
                handleNextOverride: async (intakeState, onboardingHooks) => {
                  const { updateIntakeStateAtKey } = onboardingHooks
                  updateIntakeStateAtKey({
                    governmentEmployee: intakeState.governmentEmployee,
                  })
                  return {
                    intakeState: {
                      ...intakeState,
                      governmentEmployee: intakeState.governmentEmployee,
                    },
                  }
                },
              },
              dependencies: [],
            },
            {
              id: 'employmentStatus',
              type: 'Question',
              component: OnboardingMultiOptionTile,
              tags: ['employmentDetails', 'onboarding'],
              props: {
                id: 'employmentStatus',
                preHeader: '',
                header: 'What is your employment status?',
                subHeader: 'Select one of the following:',
                helpText: '',
                expectedDataType: 'string',
                tileSize: { xs: '6' },
                optionArray: [
                  {
                    optionLabel: 'Employed',
                    optionValue: 'employed',
                    optionIcon: <WorkIcon />,
                  },
                  {
                    optionLabel: 'Retired',
                    optionValue: 'retired',
                    optionIcon: <BeachAccessIcon />,
                  },
                ],
              },
              dependencies: [{}],
            },
            {
              id: 'employerName',
              type: 'Question',
              component: OnboardingMultiQuestion,
              tags: ['employmentDetails', 'onboarding'],
              props: {
                preHeader: 'Great, that makes retirement planning easier!',
                header: 'Who is/was your employer?',
                subHeader: 'Employer details',
                questionArray: [
                  {
                    id: 'employerName',
                    label: 'Employer Name',
                    helpText: '',
                    placeholder: 'Employer Name',
                    required: false,
                    inputType: 'text',
                  },
                  {
                    id: 'dateOfHire',
                    label: 'What is your Date of Hire?',
                    placeholder: '01/01/1970',
                    required: false,
                    inputType: 'splitdate',
                    defaultDate: '1990-01-01',
                  },
                  {
                    id: 'hiddenField',
                    label: 'Hidden Field',
                    helpText: '',
                    placeholder: 'Hidden Field',
                    required: false,
                    inputType: 'text',
                    hiddenField: true,
                  },
                ],
                handleNextOverride: async (intakeState, onboardingHooks) => {
                  const { updateIntakeStateAtKey } = onboardingHooks
                  updateIntakeStateAtKey({
                    dateOfHire: '1990-01-01',
                  })
                  return {
                    intakeState: {
                      ...intakeState,
                      dateOfHire: '1990-01-01',
                    },
                  }
                },
              },
              dependencies: [{ attribute: 'governmentEmployee', value: false }],
            },
            {
              id: 'agencyTileSelector',
              type: 'Question',
              component: AgencyTileSelector,
              props: { label: 'Which agency do you work for?' },
            },
            {
              id: 'retirementSystemTileSelector',
              type: 'Question',
              component: RetirementSystemTileSelector,
              props: {},
              dependencies: [{ attribute: 'governmentEmployee', value: true }],
            },
            {
              id: 'dateOfHire',
              type: 'Question',
              component: ServiceCompDate,
              props: {
                preHeader: ' ',
                header: 'When did you start working for the government?',
                subHeader: `If you're not sure you can estimate your start year instead.`,
                helpText: '',
                questionArray: [
                  {
                    id: 'dateOfHire',
                    label: 'Service Computation Date',
                    helpText:
                      "Your official date of hire with the government, including any bought back military time. If you don't know, put your best guess or check your latest SF-50",
                    placeholder: '01/01/1990',
                    required: false,
                    inputType: 'splitdate',
                    defaultDate: '1990-01-01',
                  },
                ],
              },
              dependencies: [{ attribute: 'governmentEmployee', value: true }],
            },
            {
              id: 'onboardingSchedule',
              component: OnboardingSchedule,
              type: 'Question',
              props: {},
              dependencies: [],
            },
            {
              id: 'interstitialScheduled',
              type: 'Interstitial Screen',
              props: {
                inputType: 'displayOnly',
                subHeader: ` `,
                header: `Appointment Set!`,
                extraContent: (
                  <>
                    <Typography
                      variant="body1"
                      mb={1}
                      mt={2}
                      sx={{ lineHeight: '1.2' }}
                    >
                      A member of the PARCO team will be in touch soon to
                      confirm your appointment.
                    </Typography>
                    <Typography
                      variant="body1"
                      mb={1}
                      mt={2}
                      sx={{ lineHeight: '1.2' }}
                    >
                      In the meantime, create your account! You can then explore
                      the PARCO site and fill out more of your profile to get
                      some instant value from our platform.
                    </Typography>
                  </>
                ),
                label: 'Scheduled',
                options: null,

                appointment: true,
              },
              dependencies: [
                { attribute: 'appointmentScheduled', value: true },
              ],
            },
            {
              id: 'interstitialScheduled',
              type: 'Interstitial Screen',
              props: {
                inputType: 'displayOnly',
                subHeader: ` `,
                header: `Welcome to PARCO!`,
                extraContent: (
                  <>
                    <Typography
                      variant="body1"
                      mb={1}
                      mt={2}
                      sx={{ lineHeight: '1.2' }}
                    >
                      A member of the PARCO team will be in touch soon to set up
                      an appointment.
                    </Typography>
                    <Typography
                      variant="body1"
                      mb={1}
                      mt={2}
                      sx={{ lineHeight: '1.2' }}
                    >
                      In the meantime, create your account! You can then explore
                      the PARCO site and fill out more of your profile to get
                      some instant value from our platform.
                    </Typography>
                  </>
                ),
                label: 'Scheduled',
                options: null,

                appointment: true,
              },
              dependencies: [],
            },
          ]}
        />
      </FieldFocusProvider>
    </>
  )
}
//Full Onboarding Start without Authentication
const UnauthedFullOnboarding = () => {
  authInitialState = 'signUp'
  const { intakeState, updateIntakeStateAtKey } = useIntake()
  const [createdUser, setCreatedUser] = useState(
    localStorage.getItem('createdUser') === 'true'
  )
  const [sentToZapier, setSentToZapier] = useState(
    localStorage.getItem('sentToZapier') === 'true'
  )
  const handleNext = async () => {
    window.scrollTo({ top: -100, behavior: 'smooth' })
    await SessionInformation.setItem('demoUserInput', {
      ...intakeState,
    })
    if (
      intakeState?.firstName !== undefined &&
      intakeState?.lastName !== undefined &&
      intakeState?.phone !== undefined &&
      intakeState?.email !== undefined
    ) {
      if (!createdUser) {
        localStorage.setItem('createdUser', 'true')
        setCreatedUser(true)
        await signUpUser({ ...intakeState })

        //adding in a google tag fire for conversion tracking
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'conversion', {
            send_to: 'AW-17330571457/ffLJCKGyhu4aEMGR7sdA',
          })
        }
      }
    }
    if (
      intakeState?.firstName !== undefined &&
      intakeState?.lastName !== undefined &&
      intakeState?.phone !== undefined &&
      intakeState?.agency !== undefined
    ) {
      if (sentToZapier) return
      await fetch('https://hooks.zapier.com/hooks/catch/15607509/2tb7wuh/', {
        method: 'POST',
        body: JSON.stringify({ user: intakeState }),
      })
      localStorage.setItem('sentToZapier', 'true')
      setSentToZapier(true)
    }
  }
  return (
    <>
      <FieldFocusProvider>
        <Onboarding
          customHandleNext={handleNext}
          steps={[
            {
              id: 'onboardingBasics',
              component: OnboardingFirstLastPhoneDOB,
              type: 'Question',
            },
            {
              id: 'governmentEmployeeSelector',
              type: 'Question',
              component: OnboardingYesNo,
              tags: ['onboarding'],
              props: {
                header:
                  'Do you work for or are you retired from the federal government?',
                subHeader: 'Select one of the following:',
                id: 'governmentEmployee',
                handleNextOverride: async (intakeState, onboardingHooks) => {
                  const { updateIntakeStateAtKey } = onboardingHooks
                  updateIntakeStateAtKey({
                    governmentEmployee: intakeState.governmentEmployee,
                  })
                  return {
                    intakeState: {
                      ...intakeState,
                      governmentEmployee: intakeState.governmentEmployee,
                    },
                  }
                },
              },
              dependencies: [],
            },
            {
              id: 'employmentStatus',
              type: 'Question',
              component: OnboardingMultiOptionTile,
              tags: ['employmentDetails', 'onboarding'],
              props: {
                id: 'employmentStatus',
                preHeader: '',
                header: 'What is your employment status?',
                subHeader: 'Select one of the following:',
                helpText: '',
                expectedDataType: 'string',
                tileSize: { xs: '6' },
                optionArray: [
                  {
                    optionLabel: 'Employed',
                    optionValue: 'employed',
                    optionIcon: <WorkIcon />,
                  },
                  {
                    optionLabel: 'Retired',
                    optionValue: 'retired',
                    optionIcon: <BeachAccessIcon />,
                  },
                ],
              },
              dependencies: [{}],
            },
            {
              id: 'employerName',
              type: 'Question',
              component: OnboardingMultiQuestion,
              tags: ['employmentDetails', 'onboarding'],
              props: {
                preHeader: 'Great, that makes retirement planning easier!',
                header: 'Who is/was your employer?',
                subHeader: 'Employer details',
                questionArray: [
                  {
                    id: 'employerName',
                    label: 'Employer Name',
                    helpText: '',
                    placeholder: 'Employer Name',
                    required: false,
                    inputType: 'text',
                  },
                  {
                    id: 'dateOfHire',
                    label: 'What is your Date of Hire?',
                    placeholder: '01/01/1970',
                    required: false,
                    inputType: 'splitdate',
                    defaultDate: '1990-01-01',
                  },
                  {
                    id: 'hiddenField',
                    label: 'Hidden Field',
                    helpText: '',
                    placeholder: 'Hidden Field',
                    required: false,
                    inputType: 'text',
                    hiddenField: true,
                  },
                ],
                handleNextOverride: async (intakeState, onboardingHooks) => {
                  const { updateIntakeStateAtKey } = onboardingHooks
                  updateIntakeStateAtKey({
                    dateOfHire: '1990-01-01',
                  })
                  return {
                    intakeState: {
                      ...intakeState,
                      dateOfHire: '1990-01-01',
                    },
                  }
                },
              },
              dependencies: [{ attribute: 'governmentEmployee', value: false }],
            },
            {
              id: 'agencyTileSelector',
              type: 'Question',
              component: AgencyTileSelector,
              props: { label: 'Which agency do you work for?' },
              // additionalContext: {
              //   header: 'Why this matters:',
              //   content: (
              //     <>
              //       <Typography variant="body2">
              //         Certain agencies have specific nuances to retirement rules.
              //         The agency you work for will change our calculations and
              //         recommendations for you.
              //       </Typography>
              //     </>
              //   ),
              // },
              dependencies: [{ attribute: 'governmentEmployee', value: true }],
            },
            {
              id: 'retirementSystemTileSelector',
              type: 'Question',
              component: RetirementSystemTileSelector,
              props: {},
              dependencies: [{ attribute: 'governmentEmployee', value: true }],
            },
            {
              id: 'dateOfHire',
              type: 'Question',
              component: ServiceCompDate,
              props: {
                preHeader: ' ',
                header: 'When did you start working for the government?',
                subHeader: `If you're not sure you can estimate your start year instead.`,
                helpText: '',
                questionArray: [
                  {
                    id: 'dateOfHire',
                    label: 'Service Computation Date',
                    helpText:
                      "Your official date of hire with the government, including any bought back military time. If you don't know, put your best guess or check your latest SF-50",
                    placeholder: '01/01/1970',
                    required: false,
                    inputType: 'splitdate',
                    defaultDate: '1990-01-01',
                  },
                ],
              },
              dependencies: [{ attribute: 'governmentEmployee', value: true }],
            },
            {
              id: 'interstitialExplore',
              type: 'Interstitial Screen',
              props: {
                inputType: 'displayOnly',
                subHeader: ` `,
                extraContent: (
                  <>
                    <Typography
                      variant="headerTitle"
                      mb={1}
                      mt={2}
                      sx={{ lineHeight: '1.2', color: '#262627' }}
                    >
                      Create your PARCO Account
                    </Typography>
                    <Typography
                      variant="body1"
                      mb={1}
                      mt={2}
                      sx={{ lineHeight: '1.2', color: '#495057' }}
                    >
                      To complete your profile and get the analytics and
                      recommendations you need, continue with onboarding.
                    </Typography>
                  </>
                ),
                label: 'Scheduled',
                options: null,
                header: ` `,
                appointment: true,
              },
              dependencies: [],
            },
          ]}
        />
      </FieldFocusProvider>
    </>
  )
}

//Full Onboarding Start without Authentication
// const UnauthedForkOnboarding = () => {
//   authInitialState = 'signUp'
//   const { intakeState, updateIntakeStateAtKey } = useIntake()
//   const [createdUser, setCreatedUser] = useState(
//     localStorage.getItem('createdUser') === 'true'
//   )
//   const [sentToZapier, setSentToZapier] = useState(
//     localStorage.getItem('sentToZapier') === 'true'
//   )
//   const handleNext = async () => {
//     window.scrollTo({ top: -100, behavior: 'smooth' })
//     await SessionInformation.setItem('demoUserInput', {
//       ...intakeState,
//     })
//     if (
//       intakeState?.firstName !== undefined &&
//       intakeState?.lastName !== undefined &&
//       intakeState?.phone !== undefined
//     ) {
//       if (sentToZapier) return
//       await fetch('https://hooks.zapier.com/hooks/catch/15607509/2tb7wuh/', {
//         method: 'POST',
//         body: JSON.stringify({ user: intakeState }),
//       })
//       localStorage.setItem('sentToZapier', 'true')
//       setSentToZapier(true)
//     }
//   }
//   return (
//     <>
//       <FieldFocusProvider>
//         <Onboarding
//           customHandleNext={handleNext}
//           steps={[
//             {
//               id: 'onboardingBasics',
//               component: OnboardingFirstLastPhoneDOB,
//               type: 'Question',
//             },
//             {
//               id: 'governmentEmployeeSelector',
//               type: 'Question',
//               component: OnboardingYesNo,
//               tags: ['onboarding'],
//               props: {
//                 header:
//                   'Do you work for or are you retired from the federal government?',
//                 subHeader: 'Select one of the following:',
//                 id: 'governmentEmployee',
//                 handleNextOverride: async (intakeState, onboardingHooks) => {
//                   const { updateIntakeStateAtKey } = onboardingHooks
//                   updateIntakeStateAtKey({
//                     governmentEmployee: intakeState.governmentEmployee,
//                   })
//                   return {
//                     intakeState: {
//                       ...intakeState,
//                       governmentEmployee: intakeState.governmentEmployee,
//                     },
//                   }
//                 },
//               },
//               dependencies: [],
//             },
//             {
//               id: 'retirementSystemTileSelector',
//               type: 'Question',
//               component: RetirementSystemTileSelector,
//               props: {},
//               dependencies: [{ attribute: 'governmentEmployee', value: true }],
//             },
//             {
//               id: 'dateOfHire',
//               type: 'Question',
//               component: ServiceCompDate,
//               props: {
//                 preHeader: ' ',
//                 header: 'When did you start working for the government?',
//                 subHeader: `If you're not sure you can estimate your start year instead.`,
//                 helpText: '',
//                 questionArray: [
//                   {
//                     id: 'dateOfHire',
//                     label: 'Service Computation Date',
//                     helpText:
//                       "Your official date of hire with the government, including any bought back military time. If you don't know, put your best guess or check your latest SF-50",
//                     placeholder: '01/01/1970',
//                     required: false,
//                     inputType: 'splitdate',
//                     defaultDate: '1990-01-01',
//                   },
//                 ],
//               },
//               dependencies: [{ attribute: 'governmentEmployee', value: true }],
//             },
//             {
//               id: 'workFromHome',
//               type: 'Question',
//               component: OnboardingYesNo,
//               tags: ['buyoutFlow'],
//               props: {
//                 preHeader: `At least up until recently`,
//                 header: 'Have you been working from home?',
//                 subHeader: 'Select one of the following:',
//                 id: 'workFromHome',
//               },
//               dependencies: [{}],
//             },
//             {
//               id: 'returnToOffice',
//               type: 'Question',
//               component: OnboardingYesNo,
//               tags: ['buyoutFlow'],
//               props: {
//                 preHeader: ``,
//                 header: 'Do you want to return to the office?',
//                 subHeader: 'Select one of the following:',
//                 id: 'returnToOffice',
//               },
//               dependencies: [{}],
//             },
//             {
//               id: 'forkEvaluation',
//               type: 'Question',
//               component: OnboardingInformation,
//               tags: ['buyoutFlow'],
//               props: {
//                 preHeader: ``,
//                 header: `Evaluating the "Deferred Resignation"`,
//                 subHeader: `Consider the Pros and Cons:`,
//                 additionalContent: <></>,
//               },
//               dependencies: [{}],
//             },
//             {
//               id: 'interstitialExploreYourOptions',
//               type: 'Question',
//               component: OnboardingMultiOptionTile,
//               tags: ['buyoutFlow'],
//               props: {
//                 id: 'forkSelection',
//                 preHeader: '',
//                 header: 'Which Way Are You Leaning?',
//                 subHeader: ``,
//                 helpText: '',
//                 expectedDataType: 'string',
//                 tileSize: { xs: '12' },
//                 optionArray: [
//                   {
//                     className: 'textWithDescription',
//                     optionLabel: 'Accept The Deferred Resignation Offer',
//                     optionLabelBadge: '',
//                     optionDescription: `Resign from your job, but get paid to not work for the next 8 months.`,
//                     optionAdditionalContent: <></>,
//                     optionTimer: '',
//                     optionTimerClass: '',
//                     optionValue: 'acceptDeferredResignation',
//                   },
//                   {
//                     className: 'textWithDescription',
//                     optionLabel: 'Return To Office',
//                     optionDescription: `Plan to head back to the office for work.`,
//                     optionTimer: '',
//                     optionTimerClass: '',
//                     optionValue: 'returnToOffice',
//                   },
//                   {
//                     className: 'textWithDescription',
//                     optionLabel: `I'm Still Not Sure`,
//                     optionDescription: `PARCO will help you evaluate your options.`,
//                     optionTimer: '',
//                     optionTimerClass: '',
//                     optionValue: 'notSure',
//                   },
//                 ],
//               },
//               dependencies: [{}],
//             },
//             {
//               id: 'interstitialExploreScenarios',
//               type: 'Question',
//               component: OnboardingMultiOptionTile,
//               tags: ['buyoutFlow'],
//               props: {
//                 id: 'forkSelectionScenarios',
//                 preHeader: '',
//                 header: 'Next Steps',
//                 subHeader: `Please select one of the following:`,
//                 helpText: '',
//                 expectedDataType: 'number',
//                 tileSize: { xs: '12' },
//                 optionArray: [
//                   {
//                     className: 'textWithDescription',
//                     optionLabel: 'Schedule an Appointment',
//                     optionDescription: `Choose when you'd like to speak with a PARCO financial advisor about any questions or concerns you have. We know a lot of Feds are worried ... we're here to help.`,
//                     optionAdditionalContent: '',
//                     optionTimer: '2 min',
//                     optionTimerClass: '',
//                     optionLink: '',
//                     optionValue: 1,
//                   },
//                   {
//                     className: 'textWithDescription',
//                     optionLabel:
//                       'Unlock Your Dashboard - Complete Your Profile',
//                     optionDescription: `Finish filling out your profile for more insights.`,
//                     optionTimer: '5 - 12 min',
//                     optionLink:
//                       '/fork-flow?onboardingStep=interstitialScheduled',
//                     optionValue: 2,
//                   },
//                 ],
//               },
//               dependencies: [{}],
//             },
//             {
//               id: 'onboardingSchedule',
//               component: OnboardingSchedule,
//               type: 'Question',
//               props: {},
//               dependencies: [{ attribute: 'forkSelectionScenarios', value: 1 }],
//             },
//             {
//               id: 'interstitialScheduled',
//               type: 'Interstitial Screen',
//               props: {
//                 inputType: 'displayOnly',
//                 subHeader: ` `,
//                 extraContent: (
//                   <>
//                     <Typography
//                       variant="body1"
//                       mb={1}
//                       mt={2}
//                       sx={{ lineHeight: '1.2' }}
//                     >
//                       A member of the PARCO team will be in touch soon to
//                       confirm your appointment.
//                     </Typography>
//                     <Typography
//                       variant="body1"
//                       mb={1}
//                       mt={2}
//                       sx={{ lineHeight: '1.2' }}
//                     >
//                       In the meantime, create your account! You can then explore
//                       the PARCO site and fill out more of your profile to get
//                       some instant value from our platform.
//                     </Typography>
//                   </>
//                 ),
//                 label: 'Scheduled',
//                 options: null,
//                 header: `Appointment Set!`,
//                 appointment: true,
//               },
//               dependencies: [{ attribute: 'forkSelectionScenarios', value: 1 }],
//             },
//             {
//               id: 'interstitialExplore',
//               type: 'Interstitial Screen',
//               props: {
//                 inputType: 'displayOnly',
//                 subHeader: ` `,
//                 extraContent: (
//                   <>
//                     <Typography
//                       variant="body1"
//                       mb={1}
//                       mt={2}
//                       sx={{ lineHeight: '1.2' }}
//                     >
//                       To complete your profile and get the analytics and
//                       recommendations you need, continue with onboarding.
//                     </Typography>
//                   </>
//                 ),
//                 label: 'Scheduled',
//                 options: null,
//                 header: `Create your PARCO Account!`,
//                 appointment: true,
//               },
//               dependencies: [],
//             },
//           ]}
//         />
//       </FieldFocusProvider>
//     </>
//   )
// }

const UnauthedScheduleOnboarding = () => {
  authInitialState = 'signUp'
  const { intakeState, updateIntakeStateAtKey } = useIntake()
  const clientAge = differenceInYears(
    new Date(),
    new Date(intakeState?.dateOfBirth)
  )
  const plannedRetirementMonth = format(
    new Date(intakeState?.dateOfPlannedRetirement),
    'MMMM'
  )
  const plannedRetirementYear = format(
    new Date(intakeState?.dateOfPlannedRetirement),
    'yyyy'
  )
  const plannedRetirementAge = differenceInYears(
    new Date(intakeState?.dateOfPlannedRetirement),
    new Date(intakeState?.dateOfBirth)
  )
  const [assets, setAssets] = useState([])
  const [liabilities, setLiabilities] = useState([])
  const [deductions, setDeductions] = useState([])
  const [incomes, setIncomes] = useState([])
  const [expenses, setExpenses] = useState([])
  const {
    adjustedNetTakeHomeInRetirement,
    adjustedWorkingNetTakeHome,
    adjustedNetTakeHomeDifferencePARCOGap,
  } = useRetirementGapCalculations(deductions, liabilities, incomes, expenses)
  const { parcoReadinessScore4Percent, parcoReadinessScore3Percent } =
    usePARCOScoreCalculations(
      assets,
      liabilities,
      adjustedWorkingNetTakeHome,
      adjustedNetTakeHomeInRetirement,
      adjustedNetTakeHomeDifferencePARCOGap
    )
  const { atRetirementGrossPension, firstFullyEligibleDate } =
    useDashboardCalculations()
  const fullyEligibleRetirementAge = differenceInYears(
    new Date(firstFullyEligibleDate),
    new Date(intakeState?.dateOfBirth)
  )
  const [createdUser, setCreatedUser] = useState(
    localStorage.getItem('createdUser') === 'true'
  )
  const [sentToZapier, setSentToZapier] = useState(
    localStorage.getItem('sentToZapier') === 'true'
  )
  const [appointmentAvailability, setAppointmentAvailability] = useState(
    localStorage.getItem('appointmentAvailability') !== null
  )
  const detailsCheck =
    intakeState?.firstName !== undefined &&
    intakeState?.lastName !== undefined &&
    intakeState?.phone !== undefined &&
    intakeState?.email !== undefined

  const handleNext = async () => {
    window.scrollTo({ top: -100, behavior: 'smooth' })
    await SessionInformation.setItem('demoUserInput', {
      ...intakeState,
    })
    console.log('intakeState:', intakeState)
    if (detailsCheck) {
      if (!createdUser) {
        console.log('in create user')
        localStorage.setItem('createdUser', 'true')
        setCreatedUser(true)
        await signUpUser({ ...intakeState })

        //adding in a google tag fire for conversion tracking
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'conversion', {
            send_to: 'AW-17330571457/ffLJCKGyhu4aEMGR7sdA',
          })
        }
      }
    }
    if (detailsCheck) {
      if (!appointmentAvailability) {
        const dateToYears = (startDate, endDate) => {
          return startDate && endDate
            ? differenceInYears(new Date(endDate), new Date(startDate))
            : ''
        }
        const now = new Date()
        const endDate = new Date(now)
        endDate.setMonth(endDate.getMonth() + 2)
        const begin =
          now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate()
        const end =
          endDate.getFullYear() +
          '-' +
          (endDate.getMonth() + 1) +
          '-' +
          endDate.getDate()
        try {
          const calendarIds = []
          if (dateToYears(intakeState?.dateOfBirth, new Date()) > 59) {
            calendarIds.push(selectData.retirementStrategist[3].id)
          } else {
            //dan & john
            calendarIds.push(selectData.retirementStrategist[0].id)
            calendarIds.push(selectData.retirementStrategist[1].id)
          }
          const payload = {
            begin: begin,
            end: end,
            calendar_ids_to_check: calendarIds.join('%2C'),
          }
          const response = await fetch(
            'https://1p9cjflrkb.execute-api.us-east-2.amazonaws.com/api/users/availability',
            {
              method: 'POST',
              body: JSON.stringify(payload),
            }
          )
          const data = await response.json()

          // setData(data)

          // const availableDatesSet = new Set(
          //   data.availability.map((iso) => iso.split('T')[0])
          // )
          // setAvailableDates(availableDatesSet)
          localStorage.setItem('appointmentAvailability', data)
          setAppointmentAvailability(data)
        } catch (e) {
          console.error('Error fetching availability:', e)
        }
      }
    }
    // revisit how we want to fire this interaction
    if (detailsCheck) {
      if (sentToZapier) return
      console.log('in zapier message')
      await fetch('https://hooks.zapier.com/hooks/catch/15607509/2tb7wuh/', {
        method: 'POST',
        body: JSON.stringify({ user: intakeState }),
      })
      localStorage.setItem('sentToZapier', 'true')
      setSentToZapier(true)
    }
  }
  return (
    <>
      <FieldFocusProvider>
        <Onboarding
          customHandleNext={handleNext}
          steps={[
            {
              id: 'onboardingBasics',
              component: OnboardingContactDetails,
              type: 'Question',
            },
            {
              id: 'onboardingSchedule',
              component: OnboardingSchedule,
              type: 'Question',
              props: {},
              dependencies: [],
            },
            {
              id: 'currentAge',
              type: 'Question',
              component: OnboardingAge,
              props: {},
              dependencies: [],
            },
            {
              id: 'employmentStatus',
              type: 'Question',
              component: OnboardingMultiOptionTile,
              tags: ['employmentDetails', 'onboarding'],
              props: {
                id: 'employmentStatus',
                preHeader: '',
                header: 'What is your employment status?',
                subHeader: 'Select one of the following:',
                helpText: '',
                expectedDataType: 'string',
                tileSize: { xs: '6' },
                optionArray: [
                  {
                    optionLabel: 'Employed',
                    optionValue: 'employed',
                    optionIcon: <WorkIcon />,
                  },
                  {
                    optionLabel: 'Retired',
                    optionValue: 'retired',
                    optionIcon: <BeachAccessIcon />,
                  },
                ],
              },
              dependencies: [{}],
            },
            {
              id: 'governmentEmployeeSelector',
              type: 'Question',
              component: OnboardingYesNo,
              tags: ['onboarding'],
              props: {
                header:
                  'Do you work for or have you worked for the Federal Government?',
                subHeader: 'Select one of the following:',
                id: 'governmentEmployee',
                handleNextOverride: async (intakeState, onboardingHooks) => {
                  const { updateIntakeStateAtKey } = onboardingHooks
                  updateIntakeStateAtKey({
                    governmentEmployee: intakeState.governmentEmployee,
                  })
                  return {
                    intakeState: {
                      ...intakeState,
                      governmentEmployee: intakeState.governmentEmployee,
                    },
                  }
                },
              },
              dependencies: [
                { attribute: 'employmentStatus', value: 'employed' },
              ],
            },
            {
              id: 'retiredGovernmentEmployeeSelector',
              type: 'Question',
              component: OnboardingYesNo,
              tags: ['onboarding'],
              props: {
                header: 'Are you retired from the Federal Government?',
                subHeader: 'Select one of the following:',
                id: 'governmentEmployee',
                handleNextOverride: async (intakeState, onboardingHooks) => {
                  const { updateIntakeStateAtKey } = onboardingHooks
                  updateIntakeStateAtKey({
                    governmentEmployee: intakeState.governmentEmployee,
                  })
                  return {
                    intakeState: {
                      ...intakeState,
                      governmentEmployee: intakeState.governmentEmployee,
                    },
                  }
                },
              },
              dependencies: [
                { attribute: 'employmentStatus', value: 'retired' },
              ],
            },
            {
              id: 'retirementSystemTileSelector',
              type: 'Question',
              component: RetirementSystemTileSelector,
              props: {},
              dependencies: [{ attribute: 'governmentEmployee', value: true }],
            },
            {
              id: 'employerName',
              type: 'Question',
              component: OnboardingMultiQuestion,
              tags: ['employmentDetails', 'onboarding'],
              props: {
                preHeader: ' ',
                header: 'Who is/was your employer?',
                subHeader: 'Employer / Company Name',
                questionArray: [
                  {
                    id: 'employerName',
                    label: 'Employer Name',
                    helpText: 'Your employer / company name',
                    enableHelpText: false, // https://linear.app/parco-app/issue/PAR-1773/who-is-was-your-employer-page-changes#comment-90286186
                    placeholder: 'Employer Name',
                    required: false,
                    inputType: 'text',
                  },
                  {
                    id: 'dateOfHire',
                    label: 'What is your Date of Hire?',
                    placeholder: '01/01/1970',
                    required: false,
                    inputType: 'splitdate',
                    defaultDate: '1990-01-01',
                  },
                  {
                    id: 'hiddenField',
                    label: 'Hidden Field',
                    helpText: '',
                    placeholder: 'Hidden Field',
                    required: false,
                    inputType: 'text',
                    hiddenField: true,
                  },
                ],
                handleNextOverride: async (intakeState, onboardingHooks) => {
                  const { updateIntakeStateAtKey } = onboardingHooks
                  updateIntakeStateAtKey({
                    dateOfHire: '1990-01-01',
                  })
                  return {
                    intakeState: {
                      ...intakeState,
                      dateOfHire: '1990-01-01',
                    },
                  }
                },
              },
              dependencies: [{ attribute: 'governmentEmployee', value: false }],
            },
            {
              id: 'yearsOfService',
              type: 'Question',
              component: OnboardingServiceCompDate,
              props: {
                onboarding: true,
              },
              dependencies: [
                { attribute: 'employmentStatus', value: 'employed' },
                { attribute: 'governmentEmployee', value: true },
              ],
            },
            {
              id: 'baseSalary',
              type: 'Question',
              component: OnboardingIncome,
              props: {
                header: 'What is your annual salary?',
                subHeader:
                  'This is useful for us to calculate your pension in retirement.',
                wheelFormatterText: 'per year',
                wheelStartingValue: 60000,
                wheelIncrement: 1000,
                wheelOptionCount: 300,
                startingTextWidth: 62,
                keyToUpdate: 'baseSalary',
                fieldLabel: 'Annual Salary',
                fieldPlaceholder: '$62,000.00',
                fieldHelpText:
                  'Your Adjusted base salary is your base salary including any locality pay you receive.',
              },
              dependencies: [
                { attribute: 'employmentStatus', value: 'employed' },
                { attribute: 'governmentEmployee', value: true },
              ],
            },
            {
              id: 'privatePay',
              type: 'Question',
              component: OnboardingMultiQuestion,
              tags: ['onboarding'],
              props: {
                preHeader: ' ',
                header: 'Tell us about your key pay details',
                subHeader: ' ',
                questionArray: [
                  {
                    id: 'baseSalary',
                    label: 'Annual Salary',
                    helpText: '',
                    placeholder: 'Annual Salary',
                    required: false,
                    inputType: 'currencyFloat',
                  },
                  {
                    id: 'netTakeHome',
                    label: 'Net Take Home Per Pay Period',
                    helpText: '',
                    placeholder: 'Net Take Home Per Pay Period',
                    required: false,
                    inputType: 'currencyFloat',
                  },
                  {
                    id: 'hiddenField',
                    label: 'Hidden Field',
                    helpText: '',
                    placeholder: 'Hidden Field',
                    required: false,
                    inputType: 'text',
                    hiddenField: true,
                  },
                ],
              },
              dependencies: [
                { attribute: 'employmentStatus', value: 'employed' },
                { attribute: 'governmentEmployee', value: false },
              ],
            },
            {
              id: '401kSavings',
              component: OnboardingMultiOptionTile,
              tags: ['onboarding'],
              props: {
                id: '401k',
                preHeader: '',
                header: `How much do you have in investments, savings, and your 401k’s?`,
                subHeader:
                  'This along with your Social Security are critical pieces of your retirement puzzle.',
                helpText: '',
                expectedDataType: 'number',
                tileSize: { xs: '6' },
                optionArray: [
                  {
                    optionLabel: 'Less than $100k',
                    optionValue: 50000,
                  },
                  {
                    optionLabel: '$100k to $250k',
                    optionValue: 100000,
                  },
                  {
                    optionLabel: '$250k to $500k',
                    optionValue: 250000,
                  },
                  {
                    optionLabel: '$500k+',
                    optionValue: 500000,
                  },
                ],
              },
              dependencies: [{ attribute: 'governmentEmployee', value: false }],
            },
            // see score carrot
            {
              id: 'retirementCalculations',
              type: 'Interstitial Screen',
              props: {
                inputType: 'displayOnly',
                subHeader: `Based on the information you've provided:`,
                extraContent: (
                  <>
                    {/* Calculation Cards */}
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 3,
                        width: '100%',
                      }}
                    >
                      {/* Monthly FERS Pension Card */}
                      <Box
                        sx={{
                          backgroundColor: '#f9f9f9',
                          border: '1px solid #f1f1f1',
                          borderRadius: '8px',
                          padding: '25px',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 2,
                          width: '100%',
                        }}
                      >
                        <Box
                          sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                        >
                          <Box
                            sx={{
                              backgroundColor: '#2370ed',
                              opacity: 0.8,
                              borderRadius: '6px',
                              width: '29px',
                              height: '29px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <Typography
                              sx={{
                                color: '#FFFFFF',
                                fontSize: '18px',
                                fontWeight: 'bold',
                                fontFamily: 'Inter',
                              }}
                            >
                              {/* TODO: Add the icon here */}$
                            </Typography>
                          </Box>
                          <Typography
                            sx={{
                              fontFamily: 'Inter',
                              fontWeight: 500,
                              fontSize: '16px',
                              color: '#495057',
                              lineHeight: 1.5,
                            }}
                          >
                            Monthly FERS Pension
                          </Typography>
                        </Box>
                        <Typography
                          sx={{
                            fontFamily: 'Inter',
                            fontWeight: 800,
                            fontSize: '32px',
                            color: '#262627',
                            lineHeight: 1.167,
                          }}
                        >
                          {dollarFormat.format(atRetirementGrossPension / 12)}
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: 'Inter',
                            fontWeight: 400,
                            fontSize: '14px',
                            color: '#75787b',
                            lineHeight: 1.5,
                          }}
                        >
                          This is your estimated monthly pension payment at
                          retirement.
                        </Typography>
                      </Box>

                      {/* First Fully Eligible Retirement Age Card */}
                      <Box
                        sx={{
                          backgroundColor: '#f9f9f9',
                          border: '1px solid #f1f1f1',
                          borderRadius: '8px',
                          padding: '25px',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 2,
                          width: '100%',
                        }}
                      >
                        <Box
                          sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                        >
                          <Box
                            sx={{
                              backgroundColor: '#2370ed',
                              opacity: 0.8,
                              borderRadius: '6px',
                              width: '29px',
                              height: '29px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <Typography
                              sx={{
                                color: 'white',
                                fontSize: '12px',
                                fontWeight: 'bold',
                                fontFamily: 'Inter',
                              }}
                            >
                              {/* TODO: Add the icon here */}
                              <img src={CalendarIcon} alt="Calendar Icon" />
                            </Typography>
                          </Box>
                          <Typography
                            sx={{
                              fontFamily: 'Inter',
                              fontWeight: 500,
                              fontSize: '16px',
                              color: '#495057',
                              lineHeight: 1.5,
                            }}
                          >
                            First Fully Eligible Retirement Age
                          </Typography>
                        </Box>
                        <Typography
                          sx={{
                            fontFamily: 'Inter',
                            fontWeight: 800,
                            fontSize: '32px',
                            color: '#262627',
                            lineHeight: 1.167,
                          }}
                        >
                          Age {fullyEligibleRetirementAge}
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: 'Inter',
                            fontWeight: 400,
                            fontSize: '14px',
                            color: '#75787b',
                            lineHeight: 1.5,
                          }}
                        >
                          This is the earliest age you can retire with full
                          benefits based on your years of service and age.
                        </Typography>
                      </Box>
                    </Box>
                  </>
                ),
                label: ' ',
                options: null,
                header: `Here are a few retirement calculations!`,
                score: true,
              },
              dependencies: [
                { attribute: 'employmentStatus', value: 'employed' },
                { attribute: 'governmentEmployee', value: true },
              ],
            },
            // placeholder score
            {
              id: 'scorePlaceholder',
              type: 'Interstitial Screen',
              props: {
                inputType: 'displayOnly',
                subHeader: `Answer a few more questions so and we'll be able to estimate how ready you are for retirement.`,
                extraContent: (
                  <Banner
                    color={''}
                    type={'unlock'}
                    title="UNLOCK TILE"
                    description="Retirement Readiness"
                    arrow={false}
                    content={
                      <>
                        <Gauge value={65} hyperOnboarding={true} />
                      </>
                    }
                  />
                ),
                label: ' ',
                options: null,
                header: `See your Retirement Readiness Score!`,
                score: true,
              },
              dependencies: [
                { attribute: 'employmentStatus', value: 'employed' },
                { attribute: 'governmentEmployee', value: true },
              ],
            },
            //Contact Information Tile
            {
              id: 'tspSavings',
              component: OnboardingMultiOptionTile,
              tags: ['onboarding'],
              props: {
                id: 'tspBalance',
                preHeader: '',
                header: 'How much is in your TSP?',
                subHeader:
                  'This along with your pension and Social Security are critical pieces of your retirement puzzle.',
                helpText: '',
                expectedDataType: 'number',
                tileSize: { xs: '6' },
                optionArray: [
                  {
                    optionLabel: 'Less than $100k',
                    optionValue: 50000,
                  },
                  {
                    optionLabel: '$100k to $250k',
                    optionValue: 100000,
                  },
                  {
                    optionLabel: '$250k to $500k',
                    optionValue: 250000,
                  },
                  {
                    optionLabel: '$500k+',
                    optionValue: 500000,
                  },
                ],
              },
              dependencies: [{ attribute: 'governmentEmployee', value: true }],
            },
            {
              id: 'netTakeHome',
              type: 'Question',
              component: OnboardingIncome,
              props: {
                header: 'What is your Net Take Home per pay period?',
                subHeader:
                  'This helps us determine your Retirement Readiness Score!',
                wheelFormatterText: 'per pay period',
                wheelStartingValue: 2000,
                wheelIncrement: 100,
                wheelOptionCount: 60,
                startingTextWidth: 52,
                keyToUpdate: 'netTakeHome',
                fieldLabel: 'Net Take Home',
                fieldPlaceholder: '$2,000.00',
                fieldHelpText:
                  'How much you take home in a normal pay period net of all deductions',
              },
              dependencies: [
                { attribute: 'employmentStatus', value: 'employed' },
                { attribute: 'governmentEmployee', value: true },
              ],
            },
            //important values loader
            {
              id: 'calculatingSpinner',
              type: 'Interstitial Screen',
              props: {
                inputType: 'displayOnly',
                subHeader: ` `,
                extraContent: (
                  <>
                    <Typography
                      variant="body1"
                      mb={1}
                      mt={2}
                      sx={{ lineHeight: '1.2' }}
                    >
                      Load the Loader Spinner
                    </Typography>
                  </>
                ),
                label: ' ',
                options: null,
                header: `Calculating some important values...`,
                loaderIcon: true,
              },
              dependencies: [
                { attribute: 'employmentStatus', value: 'employed' },
              ],
            },
            {
              id: 'scoreUpdated',
              type: 'Interstitial Screen',
              props: {
                inputType: 'displayOnly',
                subHeader: `Filling in more of your profile information will help us to improve the accuracy of this score.`,
                extraContent: (
                  <Box>
                    <ScoreCard
                      key={'scoreCard'}
                      value={Math.round(
                        (clientAge >= 70
                          ? parcoReadinessScore4Percent
                          : parcoReadinessScore3Percent) * 100
                      )}
                      goal={`${plannedRetirementMonth} ${plannedRetirementYear}`}
                      type="retirement"
                    />
                  </Box>
                ),
                label: ' ',
                options: null,
                header: `Great! Your estimated score is:`,
                score: true,
              },
              dependencies: [
                { attribute: 'employmentStatus', value: 'employed' },
              ],
            },
            {
              id: 'interstitialWhatsNext',
              type: 'Question',
              component: OnboardingMultiOptionTile,
              tags: ['onboarding'],
              props: {
                id: 'whatsNext',
                preHeader: ' ',
                header: `How would you like to continue?`,
                subHeader: ` `,
                helpText: '',
                expectedDataType: 'string',
                tileSize: { xs: '12' },
                optionArray: [
                  {
                    className: 'textWithDescription',
                    optionLabel: 'Head to the Dashboard',
                    optionDescription: `Ready to skip to the good stuff? We get it. Just note that some features won't work until you share a bit more info.`,
                    optionTimer: '',
                    optionTimerClass: '',
                    optionValue: 'dashboard',
                    arrowIndicator: true,
                  },
                  {
                    className: 'textWithDescription',
                    optionLabel: `Finish Onboarding`,
                    optionLabelBadge: '',
                    optionDescription: `Complete your details so we can give you the full picture — and the most tailored recommendations possible.`,
                    optionTimer: 'Takes an average of 8 min to complete',
                    optionTimerClass: '',
                    optionValue: 'continueOnboarding',
                    arrowIndicator: true,
                  },
                ],
              },
              dependencies: [],
            },
            {
              id: 'interstitialHeadToDashboard',
              type: 'Interstitial Screen',
              props: {
                inputType: 'displayOnly',
                subHeader: ` `,
                header: ` `,
                extraContent: (
                  <>
                    <Typography
                      variant="headerTitle"
                      mb={1}
                      mt={2}
                      sx={{ lineHeight: '1.2', color: '#262627' }}
                    >
                      Create your PARCO account to head to the Dashboard
                    </Typography>
                    <Typography
                      variant="body1"
                      mb={1}
                      mt={2}
                      sx={{ lineHeight: '1.2', color: '#495057' }}
                    >
                      You can then explore the PARCO site and fill out more of
                      your profile to get some instant value from our platform.
                    </Typography>
                  </>
                ),
                options: null,
                appointment: true,
              },
              dependencies: [{ attribute: 'whatsNext', value: 'dashboard' }],
            },
            {
              id: 'interstitialContinueOnboarding',
              type: 'Interstitial Screen',
              props: {
                inputType: 'displayOnly',
                subHeader: ` `,
                header: ` `,
                extraContent: (
                  <>
                    <Typography
                      variant="headerTitle"
                      mb={1}
                      mt={2}
                      sx={{ lineHeight: '1.2', color: '#262627' }}
                    >
                      Create your PARCO account to head to finish Onboarding
                    </Typography>
                    <Typography
                      variant="body1"
                      mb={1}
                      mt={2}
                      sx={{ lineHeight: '1.2', color: '#495057' }}
                    >
                      This will allow us to provide you with a complete picture
                      of your situation, and the best recommendations possible.
                    </Typography>
                  </>
                ),
                options: null,
              },
              dependencies: [
                { attribute: 'whatsNext', value: 'continueOnboarding' },
              ],
            },
          ]}
        />
      </FieldFocusProvider>
    </>
  )
}

const UnauthedHyperOnboarding = () => {
  authInitialState = 'signUp'
  const { intakeState, updateIntakeStateAtKey } = useIntake()
  const clientAge = differenceInYears(
    new Date(),
    new Date(intakeState?.dateOfBirth)
  )
  const plannedRetirementMonth = format(
    new Date(intakeState?.dateOfPlannedRetirement),
    'MMMM'
  )
  const plannedRetirementYear = format(
    new Date(intakeState?.dateOfPlannedRetirement),
    'yyyy'
  )
  const plannedRetirementAge = differenceInYears(
    new Date(intakeState?.dateOfPlannedRetirement),
    new Date(intakeState?.dateOfBirth)
  )
  const [assets, setAssets] = useState([])
  const [liabilities, setLiabilities] = useState([])
  const [deductions, setDeductions] = useState([])
  const [incomes, setIncomes] = useState([])
  const [expenses, setExpenses] = useState([])
  const {
    adjustedNetTakeHomeInRetirement,
    adjustedWorkingNetTakeHome,
    adjustedNetTakeHomeDifferencePARCOGap,
  } = useRetirementGapCalculations(deductions, liabilities, incomes, expenses)
  const { parcoReadinessScore4Percent, parcoReadinessScore3Percent } =
    usePARCOScoreCalculations(
      assets,
      liabilities,
      adjustedWorkingNetTakeHome,
      adjustedNetTakeHomeInRetirement,
      adjustedNetTakeHomeDifferencePARCOGap
    )
  const { atRetirementGrossPension, firstFullyEligibleDate } =
    useDashboardCalculations()
  const fullyEligibleRetirementAge = differenceInYears(
    new Date(firstFullyEligibleDate),
    new Date(intakeState?.dateOfBirth)
  )
  const [createdUser, setCreatedUser] = useState(
    localStorage.getItem('createdUser') === 'true'
  )
  const [sentToZapier, setSentToZapier] = useState(
    localStorage.getItem('sentToZapier') === 'true'
  )
  const [appointmentAvailability, setAppointmentAvailability] = useState(
    localStorage.getItem('appointmentAvailability') !== null
  )
  const detailsCheck =
    intakeState?.firstName !== undefined &&
    intakeState?.lastName !== undefined &&
    intakeState?.phone !== undefined &&
    intakeState?.email !== undefined

  const handleNext = async () => {
    window.scrollTo({ top: -100, behavior: 'smooth' })
    await SessionInformation.setItem('demoUserInput', {
      ...intakeState,
    })
    console.log('intakeState:', intakeState)
    if (detailsCheck) {
      if (!createdUser) {
        console.log('in create user')
        localStorage.setItem('createdUser', 'true')
        setCreatedUser(true)
        await signUpUser({ ...intakeState })

        //adding in a google tag fire for conversion tracking
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'conversion', {
            send_to: 'AW-17330571457/ffLJCKGyhu4aEMGR7sdA',
          })
        }
      }
    }
    if (detailsCheck) {
      if (!appointmentAvailability) {
        const dateToYears = (startDate, endDate) => {
          return startDate && endDate
            ? differenceInYears(new Date(endDate), new Date(startDate))
            : ''
        }
        const now = new Date()
        const endDate = new Date(now)
        endDate.setMonth(endDate.getMonth() + 2)
        const begin =
          now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate()
        const end =
          endDate.getFullYear() +
          '-' +
          (endDate.getMonth() + 1) +
          '-' +
          endDate.getDate()
        try {
          const calendarIds = []
          if (dateToYears(intakeState?.dateOfBirth, new Date()) > 59) {
            calendarIds.push(selectData.retirementStrategist[3].id)
          } else {
            //dan & john
            calendarIds.push(selectData.retirementStrategist[0].id)
            calendarIds.push(selectData.retirementStrategist[1].id)
          }
          const payload = {
            begin: begin,
            end: end,
            calendar_ids_to_check: calendarIds.join('%2C'),
          }
          const response = await fetch(
            'https://1p9cjflrkb.execute-api.us-east-2.amazonaws.com/api/users/availability',
            {
              method: 'POST',
              body: JSON.stringify(payload),
            }
          )
          const data = await response.json()

          // setData(data)

          // const availableDatesSet = new Set(
          //   data.availability.map((iso) => iso.split('T')[0])
          // )
          // setAvailableDates(availableDatesSet)
          localStorage.setItem('appointmentAvailability', data)
          setAppointmentAvailability(data)
        } catch (e) {
          console.error('Error fetching availability:', e)
        }
      }
    }
    // revisit how we want to fire this interaction
    if (detailsCheck) {
      if (sentToZapier) return
      console.log('in zapier message')
      await fetch('https://hooks.zapier.com/hooks/catch/15607509/2tb7wuh/', {
        method: 'POST',
        body: JSON.stringify({ user: intakeState }),
      })
      localStorage.setItem('sentToZapier', 'true')
      setSentToZapier(true)
    }
  }
  return (
    <>
      <FieldFocusProvider>
        <Onboarding
          customHandleNext={handleNext}
          steps={[
            {
              id: 'currentAge',
              type: 'Question',
              component: OnboardingAge,
              props: {},
              dependencies: [],
            },
            {
              id: 'employmentStatus',
              type: 'Question',
              component: OnboardingMultiOptionTile,
              tags: ['employmentDetails', 'onboarding'],
              props: {
                id: 'employmentStatus',
                preHeader: '',
                header: 'What is your employment status?',
                subHeader: 'Select one of the following:',
                helpText: '',
                expectedDataType: 'string',
                tileSize: { xs: '6' },
                optionArray: [
                  {
                    optionLabel: 'Employed',
                    optionValue: 'employed',
                    optionIcon: <WorkIcon />,
                  },
                  {
                    optionLabel: 'Retired',
                    optionValue: 'retired',
                    optionIcon: <BeachAccessIcon />,
                  },
                ],
              },
              dependencies: [{}],
            },
            {
              id: 'governmentEmployeeSelector',
              type: 'Question',
              component: OnboardingYesNo,
              tags: ['onboarding'],
              props: {
                header:
                  'Do you work for or have you worked for the Federal Government?',
                subHeader: 'Select one of the following:',
                id: 'governmentEmployee',
                handleNextOverride: async (intakeState, onboardingHooks) => {
                  const { updateIntakeStateAtKey } = onboardingHooks
                  updateIntakeStateAtKey({
                    governmentEmployee: intakeState.governmentEmployee,
                  })
                  return {
                    intakeState: {
                      ...intakeState,
                      governmentEmployee: intakeState.governmentEmployee,
                    },
                  }
                },
              },
              dependencies: [
                { attribute: 'employmentStatus', value: 'employed' },
              ],
            },
            {
              id: 'retiredGovernmentEmployeeSelector',
              type: 'Question',
              component: OnboardingYesNo,
              tags: ['onboarding'],
              props: {
                header: 'Are you retired from the Federal Government?',
                subHeader: 'Select one of the following:',
                id: 'governmentEmployee',
                handleNextOverride: async (intakeState, onboardingHooks) => {
                  const { updateIntakeStateAtKey } = onboardingHooks
                  updateIntakeStateAtKey({
                    governmentEmployee: intakeState.governmentEmployee,
                  })
                  return {
                    intakeState: {
                      ...intakeState,
                      governmentEmployee: intakeState.governmentEmployee,
                    },
                  }
                },
              },
              dependencies: [
                { attribute: 'employmentStatus', value: 'retired' },
              ],
            },
            {
              id: 'retirementSystemTileSelector',
              type: 'Question',
              component: RetirementSystemTileSelector,
              props: {},
              dependencies: [{ attribute: 'governmentEmployee', value: true }],
            },
            {
              id: 'employerName',
              type: 'Question',
              component: OnboardingMultiQuestion,
              tags: ['employmentDetails', 'onboarding'],
              props: {
                preHeader: ' ',
                header: 'Who is/was your employer?',
                subHeader: 'Employer / Company Name',
                questionArray: [
                  {
                    id: 'employerName',
                    label: 'Employer Name',
                    helpText: 'Your employer / company name',
                    enableHelpText: false, // https://linear.app/parco-app/issue/PAR-1773/who-is-was-your-employer-page-changes#comment-90286186
                    placeholder: 'Employer Name',
                    required: false,
                    inputType: 'text',
                  },
                  {
                    id: 'dateOfHire',
                    label: 'What is your Date of Hire?',
                    placeholder: '01/01/1970',
                    required: false,
                    inputType: 'splitdate',
                    defaultDate: '1990-01-01',
                  },
                  {
                    id: 'hiddenField',
                    label: 'Hidden Field',
                    helpText: '',
                    placeholder: 'Hidden Field',
                    required: false,
                    inputType: 'text',
                    hiddenField: true,
                  },
                ],
                handleNextOverride: async (intakeState, onboardingHooks) => {
                  const { updateIntakeStateAtKey } = onboardingHooks
                  updateIntakeStateAtKey({
                    dateOfHire: '1990-01-01',
                  })
                  return {
                    intakeState: {
                      ...intakeState,
                      dateOfHire: '1990-01-01',
                    },
                  }
                },
              },
              dependencies: [{ attribute: 'governmentEmployee', value: false }],
            },
            {
              id: 'yearsOfService',
              type: 'Question',
              component: OnboardingServiceCompDate,
              props: {
                onboarding: true,
              },
              dependencies: [
                { attribute: 'employmentStatus', value: 'employed' },
                { attribute: 'governmentEmployee', value: true },
              ],
            },
            {
              id: 'baseSalary',
              type: 'Question',
              component: OnboardingIncome,
              props: {
                header: 'What is your annual salary?',
                subHeader:
                  'This is useful for us to calculate your pension in retirement.',
                wheelFormatterText: 'per year',
                wheelStartingValue: 60000,
                wheelIncrement: 1000,
                wheelOptionCount: 300,
                startingTextWidth: 62,
                keyToUpdate: 'baseSalary',
                fieldLabel: 'Annual Salary',
                fieldPlaceholder: '$62,000.00',
                fieldHelpText:
                  'Your Adjusted base salary is your base salary including any locality pay you receive.',
              },
              dependencies: [
                { attribute: 'employmentStatus', value: 'employed' },
                { attribute: 'governmentEmployee', value: true },
              ],
            },
            {
              id: 'privatePay',
              type: 'Question',
              component: OnboardingMultiQuestion,
              tags: ['onboarding'],
              props: {
                preHeader: ' ',
                header: 'Tell us about your key pay details',
                subHeader: ' ',
                questionArray: [
                  {
                    id: 'baseSalary',
                    label: 'Annual Salary',
                    helpText: '',
                    placeholder: 'Annual Salary',
                    required: false,
                    inputType: 'currencyFloat',
                  },
                  {
                    id: 'netTakeHome',
                    label: 'Net Take Home Per Pay Period',
                    helpText: '',
                    placeholder: 'Net Take Home Per Pay Period',
                    required: false,
                    inputType: 'currencyFloat',
                  },
                  {
                    id: 'hiddenField',
                    label: 'Hidden Field',
                    helpText: '',
                    placeholder: 'Hidden Field',
                    required: false,
                    inputType: 'text',
                    hiddenField: true,
                  },
                ],
              },
              dependencies: [
                { attribute: 'employmentStatus', value: 'employed' },
                { attribute: 'governmentEmployee', value: false },
              ],
            },
            {
              id: '401kSavings',
              component: OnboardingMultiOptionTile,
              tags: ['onboarding'],
              props: {
                id: '401k',
                preHeader: '',
                header: `How much do you have in investments, savings, and your 401k’s?`,
                subHeader:
                  'This along with your Social Security are critical pieces of your retirement puzzle.',
                helpText: '',
                expectedDataType: 'number',
                tileSize: { xs: '6' },
                optionArray: [
                  {
                    optionLabel: 'Less than $100k',
                    optionValue: 50000,
                  },
                  {
                    optionLabel: '$100k to $250k',
                    optionValue: 100000,
                  },
                  {
                    optionLabel: '$250k to $500k',
                    optionValue: 250000,
                  },
                  {
                    optionLabel: '$500k+',
                    optionValue: 500000,
                  },
                ],
              },
              dependencies: [{ attribute: 'governmentEmployee', value: false }],
            },
            // see score carrot
            {
              id: 'retirementCalculations',
              type: 'Interstitial Screen',
              props: {
                inputType: 'displayOnly',
                subHeader: `Based on the information you've provided:`,
                extraContent: (
                  <>
                    {/* Calculation Cards */}
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 3,
                        width: '100%',
                      }}
                    >
                      {/* Monthly FERS Pension Card */}
                      <Box
                        sx={{
                          backgroundColor: '#f9f9f9',
                          border: '1px solid #f1f1f1',
                          borderRadius: '8px',
                          padding: '25px',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 2,
                          width: '100%',
                        }}
                      >
                        <Box
                          sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                        >
                          <Box
                            sx={{
                              backgroundColor: '#2370ed',
                              opacity: 0.8,
                              borderRadius: '6px',
                              width: '29px',
                              height: '29px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <Typography
                              sx={{
                                color: '#FFFFFF',
                                fontSize: '18px',
                                fontWeight: 'bold',
                                fontFamily: 'Inter',
                              }}
                            >
                              {/* TODO: Add the icon here */}$
                            </Typography>
                          </Box>
                          <Typography
                            sx={{
                              fontFamily: 'Inter',
                              fontWeight: 500,
                              fontSize: '16px',
                              color: '#495057',
                              lineHeight: 1.5,
                            }}
                          >
                            Monthly FERS Pension
                          </Typography>
                        </Box>
                        <Typography
                          sx={{
                            fontFamily: 'Inter',
                            fontWeight: 800,
                            fontSize: '32px',
                            color: '#262627',
                            lineHeight: 1.167,
                          }}
                        >
                          {dollarFormat.format(atRetirementGrossPension / 12)}
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: 'Inter',
                            fontWeight: 400,
                            fontSize: '14px',
                            color: '#75787b',
                            lineHeight: 1.5,
                          }}
                        >
                          This is your estimated monthly pension payment at
                          retirement.
                        </Typography>
                      </Box>

                      {/* First Fully Eligible Retirement Age Card */}
                      <Box
                        sx={{
                          backgroundColor: '#f9f9f9',
                          border: '1px solid #f1f1f1',
                          borderRadius: '8px',
                          padding: '25px',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 2,
                          width: '100%',
                        }}
                      >
                        <Box
                          sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                        >
                          <Box
                            sx={{
                              backgroundColor: '#2370ed',
                              opacity: 0.8,
                              borderRadius: '6px',
                              width: '29px',
                              height: '29px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <Typography
                              sx={{
                                color: 'white',
                                fontSize: '12px',
                                fontWeight: 'bold',
                                fontFamily: 'Inter',
                              }}
                            >
                              {/* TODO: Add the icon here */}
                              <img src={CalendarIcon} alt="Calendar Icon" />
                            </Typography>
                          </Box>
                          <Typography
                            sx={{
                              fontFamily: 'Inter',
                              fontWeight: 500,
                              fontSize: '16px',
                              color: '#495057',
                              lineHeight: 1.5,
                            }}
                          >
                            First Fully Eligible Retirement Age
                          </Typography>
                        </Box>
                        <Typography
                          sx={{
                            fontFamily: 'Inter',
                            fontWeight: 800,
                            fontSize: '32px',
                            color: '#262627',
                            lineHeight: 1.167,
                          }}
                        >
                          Age {fullyEligibleRetirementAge}
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: 'Inter',
                            fontWeight: 400,
                            fontSize: '14px',
                            color: '#75787b',
                            lineHeight: 1.5,
                          }}
                        >
                          This is the earliest age you can retire with full
                          benefits based on your years of service and age.
                        </Typography>
                      </Box>
                    </Box>
                  </>
                ),
                label: ' ',
                options: null,
                header: `Here are a few retirement calculations!`,
                score: true,
              },
              dependencies: [
                { attribute: 'employmentStatus', value: 'employed' },
                { attribute: 'governmentEmployee', value: true },
              ],
            },
            // placeholder score
            {
              id: 'scorePlaceholder',
              type: 'Interstitial Screen',
              props: {
                inputType: 'displayOnly',
                subHeader: `Answer a few more questions so and we'll be able to estimate how ready you are for retirement.`,
                extraContent: (
                  <Banner
                    color={''}
                    type={'unlock'}
                    title="UNLOCK TILE"
                    description="Retirement Readiness"
                    arrow={false}
                    content={
                      <>
                        <Gauge value={65} hyperOnboarding={true} />
                      </>
                    }
                  />
                ),
                label: ' ',
                options: null,
                header: `See your Retirement Readiness Score!`,
                score: true,
              },
              dependencies: [
                { attribute: 'employmentStatus', value: 'employed' },
                { attribute: 'governmentEmployee', value: true },
              ],
            },
            //Contact Information Tile
            {
              id: 'onboardingBasics',
              component: OnboardingContactDetails,
              type: 'Question',
              dependencies: [{ attribute: 'governmentEmployee', value: true }],
            },
            {
              id: 'tspSavings',
              component: OnboardingMultiOptionTile,
              tags: ['onboarding'],
              props: {
                id: 'tspBalance',
                preHeader: '',
                header: 'How much is in your TSP?',
                subHeader:
                  'This along with your pension and Social Security are critical pieces of your retirement puzzle.',
                helpText: '',
                expectedDataType: 'number',
                tileSize: { xs: '6' },
                optionArray: [
                  {
                    optionLabel: 'Less than $100k',
                    optionValue: 50000,
                  },
                  {
                    optionLabel: '$100k to $250k',
                    optionValue: 100000,
                  },
                  {
                    optionLabel: '$250k to $500k',
                    optionValue: 250000,
                  },
                  {
                    optionLabel: '$500k+',
                    optionValue: 500000,
                  },
                ],
              },
              dependencies: [{ attribute: 'governmentEmployee', value: true }],
            },
            {
              id: 'netTakeHome',
              type: 'Question',
              component: OnboardingIncome,
              props: {
                header: 'What is your Net Take Home per pay period?',
                subHeader:
                  'This helps us determine your Retirement Readiness Score!',
                wheelFormatterText: 'per pay period',
                wheelStartingValue: 2000,
                wheelIncrement: 100,
                wheelOptionCount: 60,
                startingTextWidth: 52,
                keyToUpdate: 'netTakeHome',
                fieldLabel: 'Net Take Home',
                fieldPlaceholder: '$2,000.00',
                fieldHelpText:
                  'How much you take home in a normal pay period net of all deductions',
              },
              dependencies: [
                { attribute: 'employmentStatus', value: 'employed' },
                { attribute: 'governmentEmployee', value: true },
              ],
            },
            //important values loader
            {
              id: 'calculatingSpinner',
              type: 'Interstitial Screen',
              props: {
                inputType: 'displayOnly',
                subHeader: ` `,
                extraContent: (
                  <>
                    <Typography
                      variant="body1"
                      mb={1}
                      mt={2}
                      sx={{ lineHeight: '1.2' }}
                    >
                      Load the Loader Spinner
                    </Typography>
                  </>
                ),
                label: ' ',
                options: null,
                header: `Calculating some important values...`,
                loaderIcon: true,
              },
              dependencies: [
                { attribute: 'employmentStatus', value: 'employed' },
              ],
            },
            {
              id: 'scoreUpdated',
              type: 'Interstitial Screen',
              props: {
                inputType: 'displayOnly',
                subHeader: `Filling in more of your profile information will help us to improve the accuracy of this score.`,
                extraContent: (
                  <Box>
                    <ScoreCard
                      key={'scoreCard'}
                      value={Math.round(
                        (clientAge >= 70
                          ? parcoReadinessScore4Percent
                          : parcoReadinessScore3Percent) * 100
                      )}
                      goal={`${plannedRetirementMonth} ${plannedRetirementYear}`}
                      type="retirement"
                    />
                  </Box>
                ),
                label: ' ',
                options: null,
                header: `Great! Your estimated score is:`,
                score: true,
              },
              dependencies: [
                { attribute: 'employmentStatus', value: 'employed' },
              ],
            },
            {
              id: 'onboardingBasics',
              component: OnboardingContactDetails,
              type: 'Question',
              dependencies: [
                { attribute: 'employmentStatus', value: 'employed' },
                { attribute: 'governmentEmployee', value: false },
              ],
            },
            {
              id: 'interstitialWhatsNext',
              type: 'Question',
              component: OnboardingMultiOptionTile,
              tags: ['onboarding'],
              props: {
                id: 'whatsNext',
                preHeader: ' ',
                header: `How would you like to continue?`,
                subHeader: ` `,
                helpText: '',
                expectedDataType: 'string',
                tileSize: { xs: '12' },
                optionArray: [
                  {
                    className: 'textWithDescription',
                    optionLabel: 'Set an Appointment',
                    optionLabelBadge: 'Recommended',
                    optionDescription: `Schedule a time with a PARCO team member so we can better understand your situation.`,
                    optionAdditionalContent: <></>,
                    optionTimer: '',
                    optionTimerClass: '',
                    optionValue: 'scheduleAppointment',
                    arrowIndicator: true,
                  },
                  {
                    className: 'textWithDescription',
                    optionLabel: 'Head to the Dashboard',
                    optionDescription: `Ready to skip to the good stuff? We get it. Just note that some features won't work until you share a bit more info.`,
                    optionTimer: '',
                    optionTimerClass: '',
                    optionValue: 'dashboard',
                    arrowIndicator: true,
                  },
                  {
                    className: 'textWithDescription',
                    optionLabel: `Finish Onboarding`,
                    optionLabelBadge: '',
                    optionDescription: `Complete your details so we can give you the full picture — and the most tailored recommendations possible.`,
                    optionTimer: 'Takes an average of 8 min to complete',
                    optionTimerClass: '',
                    optionValue: 'continueOnboarding',
                    arrowIndicator: true,
                  },
                ],
              },
              dependencies: [],
            },
            {
              id: 'onboardingSchedule',
              component: OnboardingSchedule,
              type: 'Question',
              props: {
                prefetchedAvailability: appointmentAvailability,
              },
              dependencies: [
                { attribute: 'whatsNext', value: 'scheduleAppointment' },
              ],
            },
            {
              id: 'interstitialScheduled',
              type: 'Interstitial Screen',
              props: {
                inputType: 'displayOnly',
                subHeader: ` `,
                header: `Appointment Set!`,
                extraContent: (
                  <>
                    <Typography
                      variant="body1"
                      mb={1}
                      mt={2}
                      sx={{ lineHeight: '1.2' }}
                    >
                      A member of the PARCO team will be in touch soon to
                      confirm your appointment.
                    </Typography>
                    <Typography
                      variant="body1"
                      mb={1}
                      mt={2}
                      sx={{ lineHeight: '1.2' }}
                    >
                      In the meantime, create your account! You can then explore
                      the PARCO site and fill out more of your profile to get
                      some instant value from our platform.
                    </Typography>
                  </>
                ),
                label: 'Scheduled',
                options: null,
                appointment: true,
              },
              dependencies: [
                { attribute: 'whatsNext', value: 'scheduleAppointment' },
                { attribute: 'appointmentScheduled', value: true },
              ],
            },
            {
              id: 'interstitialScheduled',
              type: 'Interstitial Screen',
              props: {
                inputType: 'displayOnly',
                subHeader: ` `,
                header: `Welcome to PARCO!`,
                extraContent: (
                  <>
                    <Typography
                      variant="body1"
                      mb={1}
                      mt={2}
                      sx={{ lineHeight: '1.2' }}
                    >
                      A member of the PARCO team will be in touch soon to set up
                      an appointment.
                    </Typography>
                    <Typography
                      variant="body1"
                      mb={1}
                      mt={2}
                      sx={{ lineHeight: '1.2' }}
                    >
                      In the meantime, create your account! You can then explore
                      the PARCO site and fill out more of your profile to get
                      some instant value from our platform.
                    </Typography>
                  </>
                ),
                label: 'Scheduled',
                options: null,

                appointment: true,
              },
              dependencies: [
                { attribute: 'whatsNext', value: 'scheduleAppointment' },
              ],
            },
            {
              id: 'interstitialHeadToDashboard',
              type: 'Interstitial Screen',
              props: {
                inputType: 'displayOnly',
                subHeader: ` `,
                header: ` `,
                extraContent: (
                  <>
                    <Typography
                      variant="headerTitle"
                      mb={1}
                      mt={2}
                      sx={{ lineHeight: '1.2', color: '#262627' }}
                    >
                      Create your PARCO account to head to the Dashboard
                    </Typography>
                    <Typography
                      variant="body1"
                      mb={1}
                      mt={2}
                      sx={{ lineHeight: '1.2', color: '#495057' }}
                    >
                      You can then explore the PARCO site and fill out more of
                      your profile to get some instant value from our platform.
                    </Typography>
                  </>
                ),
                options: null,
                appointment: true,
              },
              dependencies: [{ attribute: 'whatsNext', value: 'dashboard' }],
            },
            {
              id: 'interstitialContinueOnboarding',
              type: 'Interstitial Screen',
              props: {
                inputType: 'displayOnly',
                subHeader: ` `,
                header: ` `,
                extraContent: (
                  <>
                    <Typography
                      variant="headerTitle"
                      mb={1}
                      mt={2}
                      sx={{ lineHeight: '1.2', color: '#262627' }}
                    >
                      Create your PARCO account to head to finish Onboarding
                    </Typography>
                    <Typography
                      variant="body1"
                      mb={1}
                      mt={2}
                      sx={{ lineHeight: '1.2', color: '#495057' }}
                    >
                      This will allow us to provide you with a complete picture
                      of your situation, and the best recommendations possible.
                    </Typography>
                  </>
                ),
                options: null,
              },
              dependencies: [
                { attribute: 'whatsNext', value: 'continueOnboarding' },
              ],
            },
          ]}
        />
      </FieldFocusProvider>
    </>
  )
}

const UnauthenticatedStuff = () => {
  const navigate = useNavigate()
  useEffect(() => {
    checkUserLoggedIn(navigate)
  }, [navigate])
  return (
    <ThemeProvider theme={theme}>
      <AnonymousContext>
        <FieldFocusProvider>
          <UnauthedOnboarding />
        </FieldFocusProvider>
      </AnonymousContext>
    </ThemeProvider>
  )
}

const UnauthenticatedLanding = () => {
  const navigate = useNavigate()
  useEffect(() => {
    checkUserLoggedIn(navigate)
  }, [navigate])
  return (
    <ThemeProvider theme={theme}>
      <AnonymousContext>
        <FieldFocusProvider>
          <OnboardingSelector />
        </FieldFocusProvider>
      </AnonymousContext>
    </ThemeProvider>
  )
}

const UnauthenticatedLandingFork = () => {
  const navigate = useNavigate()
  useEffect(() => {
    checkUserLoggedIn(navigate)
  }, [navigate])
  return (
    <ThemeProvider theme={theme}>
      <AnonymousContext>
        <FieldFocusProvider>
          <OnboardingSelectorFork />
        </FieldFocusProvider>
      </AnonymousContext>
    </ThemeProvider>
  )
}

const UnauthenticatedSchedule = () => {
  const navigate = useNavigate()
  useEffect(() => {
    checkUserLoggedIn(navigate)
  }, [navigate])
  return (
    <ThemeProvider theme={theme}>
      <AnonymousContext>
        <FieldFocusProvider>
          <UnauthedScheduleOnboarding />
        </FieldFocusProvider>
      </AnonymousContext>
    </ThemeProvider>
  )
}

// const UnauthenticatedForkOnboarding = () => {
//   const navigate = useNavigate()
//   useEffect(() => {
//     checkUserLoggedIn(navigate)
//   }, [navigate])
//   return (
//     <ThemeProvider theme={theme}>
//       <AnonymousContext>
//         <FieldFocusProvider>
//           <UnauthedForkOnboarding />
//         </FieldFocusProvider>
//       </AnonymousContext>
//     </ThemeProvider>
//   )
// }

const UnauthenticatedQuickLanding = () => {
  const navigate = useNavigate()
  useEffect(() => {
    checkUserLoggedIn(navigate)
  }, [navigate])
  return (
    <ThemeProvider theme={theme}>
      <AnonymousContext>
        <FieldFocusProvider>
          <OnboardingSelectorHyper />
        </FieldFocusProvider>
      </AnonymousContext>
    </ThemeProvider>
  )
}

const UnauthenticatedQuickOnboarding = () => {
  const navigate = useNavigate()
  useEffect(() => {
    checkUserLoggedIn(navigate)
  }, [navigate])
  return (
    <ThemeProvider theme={theme}>
      <AnonymousContext>
        <FieldFocusProvider>
          <UnauthedHyperOnboarding />
        </FieldFocusProvider>
      </AnonymousContext>
    </ThemeProvider>
  )
}

const UnauthenticatedFullOnboarding = () => {
  const navigate = useNavigate()
  useEffect(() => {
    checkUserLoggedIn(navigate)
  }, [navigate])
  return (
    <ThemeProvider theme={theme}>
      <AnonymousContext>
        <FieldFocusProvider>
          <UnauthedFullOnboarding />
        </FieldFocusProvider>
      </AnonymousContext>
    </ThemeProvider>
  )
}

const App = () => {
  return (
    <>
      <Router>
        <ToastStyleOverride />
        <ToastContainer />
        <Routes>
          <Route path="oauth-login" element={<Login />} />
          <Route path="callback" element={<OauthCallbackPage />} />
          <Route
            exact
            path="/seminar"
            element={<UnauthenticatedStuff />}
            key={'seminar-flow'}
          />
          <Route
            exact
            path="/walter-reed"
            element={<UnauthenticatedStuff />}
            key={'walter-reed'}
          />
          <Route
            exact
            path="/event"
            element={<UnauthenticatedQuickOnboarding />}
            key={'event'}
          />
          <Route
            exact
            path="/complementary"
            element={<UnauthenticatedStuff />}
            key={'frn1'}
          />
          <Route
            exact
            path="/report"
            element={<UnauthenticatedStuff />}
            key={'frn2'}
          />
          <Route
            exact
            path="/firststep"
            element={<UnauthenticatedStuff />}
            key={'frn3'}
          />
          <Route
            exact
            path="/full"
            element={<UnauthenticatedStuff />}
            key={'full'}
          />
          <Route
            exact
            path="/ic"
            element={<UnauthenticatedStuff />}
            key={'ic'}
          />
          <Route
            exact
            path="/fork"
            element={<UnauthenticatedLanding />}
            key={'fork'}
          />
          <Route
            exact
            path="/schedule"
            element={<UnauthenticatedSchedule />}
            key={'schedule'}
          />
          <Route
            exact
            path="/"
            element={<UnauthenticatedQuickLanding />}
            key={'landing'}
          />
          <Route
            exact
            path="/fork-flow"
            element={<UnauthenticatedLanding />}
            key={'forkflow'}
          />
          <Route
            exact
            path="/quick"
            element={<UnauthenticatedQuickLanding />}
            key={'quick'}
          />
          <Route
            exact
            path="/quick-onboarding"
            element={<UnauthenticatedQuickOnboarding />}
            key={'quickflow'}
          />
          <Route
            exact
            path="/onboarding-flow"
            // For Seminars
            // element={<UnauthenticatedStuff />}
            // Regular
            element={<UnauthenticatedFullOnboarding />}
            key={'landing2'}
          />
          <Route
            exact
            path="/onboarding"
            element={<UnauthenticatedFullOnboarding />}
            key={'landing3'}
          />
          <Route path="*" element={<AuthenticatedStuff />} />
        </Routes>
      </Router>
    </>
  )
}

export default App
